// Admin › Settings › Referral Program — who owes, paid, was waived or refunded.
import type { EntryFeeState } from '../../api/entryFee'
import type { LocalizedDict } from '../index'

export type RewardsEntryFeesStrings = {
  title: string
  subtitle: string
  loading: string
  loadError: string
  retry: string
  empty: string
  columns: { org: string; state: string; amount: string; when: string; actions: string }
  states: Record<Exclude<EntryFeeState, 'not_required'>, string>
  waive: string
  waiveTitle: (org: string) => string
  waiveBody: string
  reasonLabel: string
  reasonPlaceholder: string
  reasonRequired: string
  cancel: string
  confirm: string
  saving: string
}

export const rewardsEntryFeesI18n: LocalizedDict<RewardsEntryFeesStrings> = {
  en: {
    title: 'Entry fees',
    subtitle: 'Sellers who joined after the program was switched on. Refunds are made in Stripe.',
    loading: 'Loading…',
    loadError: "Couldn't load the entry fees.",
    retry: 'Try again',
    empty: 'No seller owes or has paid the entry fee yet.',
    columns: { org: 'Seller', state: 'Status', amount: 'Fee', when: 'Date', actions: 'Actions' },
    states: { due: 'Waiting for payment', paid: 'Paid', waived: 'Waived', refunded: 'Refunded' },
    waive: 'Waive',
    waiveTitle: (org) => `Let ${org} in without paying?`,
    waiveBody: 'The seller skips the entry fee and gets no entry credit. This cannot be undone.',
    reasonLabel: 'Reason',
    reasonPlaceholder: 'e.g. Pilot seller, agreed in person',
    reasonRequired: 'Write at least 3 characters.',
    cancel: 'Cancel',
    confirm: 'Waive the fee',
    saving: 'Saving…',
  },
  tr: {
    title: 'Giriş ücretleri',
    subtitle: 'Program açıldıktan sonra katılan satıcılar. İadeler Stripe üzerinden yapılır.',
    loading: 'Yükleniyor…',
    loadError: 'Giriş ücretleri yüklenemedi.',
    retry: 'Tekrar dene',
    empty: 'Henüz giriş ücreti ödeyen ya da bekleyen satıcı yok.',
    columns: { org: 'Satıcı', state: 'Durum', amount: 'Ücret', when: 'Tarih', actions: 'İşlemler' },
    states: { due: 'Ödeme bekleniyor', paid: 'Ödendi', waived: 'Muaf tutuldu', refunded: 'İade edildi' },
    waive: 'Muaf tut',
    waiveTitle: (org) => `${org} ödemeden girsin mi?`,
    waiveBody: 'Satıcı giriş ücretini atlar ve giriş kredisi almaz. Geri alınamaz.',
    reasonLabel: 'Gerekçe',
    reasonPlaceholder: 'ör. Pilot satıcı, yüz yüze anlaşıldı',
    reasonRequired: 'En az 3 karakter yaz.',
    cancel: 'Vazgeç',
    confirm: 'Ücreti muaf tut',
    saving: 'Kaydediliyor…',
  },
}
